import React from 'react';

import TicketsApi from '../../../Api/CRM/Modules/TicketsApi';
import GetLotteryTicketLineResponse from '../../../Api/CRM/Responses/LotteryTicketLineResponse';
import { getTicketLinePrizeGrossFormatted } from '../../../utils/formatters';
import Search from '../../elements/Search';
import Card from '../../elements/common/Card';
import ColoredStatus from '../../elements/common/ColoredStatus';
import { TableCell as Cell } from '../../elements/common/TableDetailsRow';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import renderNumbers from '../../elements/lotteries/Numbers';
import Paginator from '../../elements/paginator';
import useAutoPaginator from '../../hooks/useAutoPaginator';

function TicketLines({ ticketId }: Readonly<{ ticketId: number }>) {
    const { items: lines, isLoading, auto } = useAutoPaginator<GetLotteryTicketLineResponse>((page, params) =>
        TicketsApi.getLines(ticketId, page, { params })
    );

    return (
        <Card title="Lines">
            <Search {...auto.search} />
            <TableLoader isLoading={isLoading}>
                <table className="table">
                    <TableHead>
                        <th>Numbers</th>
                        <th>Status</th>
                        <th>Price stake</th>
                        <th>Prize stake</th>
                        <th>Prize</th>
                        <th>Tier</th>
                    </TableHead>
                    <tbody>
                        {lines.map((line) => (
                            <tr key={line.id}>
                                <td>{renderNumbers(line.numbers, line.lottery_id, line.lottery_type)}</td>
                                <Cell>
                                    <ColoredStatus status={line.status} />
                                </Cell>
                                <Cell>{line.price_stake}</Cell>
                                <Cell>{line.prize_stake}</Cell>
                                <Cell>{`${getTicketLinePrizeGrossFormatted(line, true)}  ${
                                    line.prize_in_kind_name ? `(received as ${line.prize_in_kind_name})` : ''
                                }`}</Cell>
                                <Cell>{line.tier}</Cell>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

export default TicketLines;
